import { MenuItem } from "@szhsin/react-menu";
import styled from "styled-components";

export const CustomMenuItem = styled(MenuItem)`
  color: white;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.yellow} !important;
    color: black !important;
  }
`;
